import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import styles from "./MobileMenu.module.css";
import useMyAccount from "../../hooks/useMyAccount";

const MobileMenu = ({ onWhatsappButton, isOpen, handleCloseButton }) => {
  const { isLoggedIn } = useAuth();
  const { logout } = useAuth();
  const buttonAuth = isLoggedIn ? "/minha-conta/perfil" : "/autenticacao";
  const { userData, collaborators } = useMyAccount();

  return (
    <div
      onMouseLeave={handleCloseButton}
      id="ltn__utilize-mobile-menu"
      className={`ltn__utilize ltn__utilize-mobile-menu ${
        isOpen ? "expanded" : ""
      }`}
      style={{
        boxShadow: "0 0 50px 0 rgba(46, 56, 220, 0.2)",
        padding: 0,
      }}
    >
      <div className={styles.title}>
        <button type="button" title={isLoggedIn ? "Minha conta" : "Login"}>
          <Link to={buttonAuth} title={isLoggedIn ? "Minha conta" : "Login"}>
            {isLoggedIn ? (
              <>
                <i
                  className="fas fa-user"
                  style={{
                    color: "var(--ltn__secondary-color)",
                    fontSize: "16px",
                    marginRight: "8px",
                  }}
                ></i>
                Olá,{" "}
                {userData && userData.user_name
                  ? userData.user_name.split(" ")[0]
                  : ""}
              </>
            ) : (
              <>
                <i
                  className="fas fa-user"
                  style={{
                    color: "var(--ltn__secondary-color)",
                    fontSize: "16px",
                    marginRight: "8px",
                  }}
                ></i>
                Olá, faça seu login
              </>
            )}
          </Link>
        </button>
        <button
          type="button"
          onClick={handleCloseButton}
          className="ltn__utilize-close"
          title="Fechar menu"
          aria-label="Fechar menu"
        >
          ×
        </button>
      </div>
      <div style={{ padding: "0 16px " }}>
        <nav>
          <ul style={{ listStyle: "none", color: "#000" }}>
            <li className={styles.text}>
              <i className="fas fa-home"></i>
              <Link to="/" title="Página inicial">
                Página Inicial
              </Link>
            </li>
            <li className={styles.text}>
              <i className="fas fa-shopping-basket"></i>
              <Link to="/produtos" title="Produtos">
                Produtos
              </Link>
            </li>
            <li className={styles.text}>
              <i className="fas fa-video"></i>
              <Link to="/videos" title="Vídeos">
                Vídeos
              </Link>
            </li>
            <li className={styles.text}>
              <i className="fas fa-shopping-cart"></i>
              <Link to="/carrinho" title="Carrinho">
                Carrinho
              </Link>
            </li>
            {isLoggedIn && (
              <>
                <li
                  style={{ borderBottom: "1px solid #E3E3E3", margin: 0 }}
                ></li>
                <li className={styles.text}>
                  <i className="fas fa-user"></i>
                  <Link to="/minha-conta/perfil" title="Minha conta">
                    Minha Conta
                  </Link>
                </li>
                <li className={styles.text}>
                  <i className="fas fa-briefcase"></i>
                  <Link to="/minha-conta/contato" title="Meu contato Terra">
                    Meu Contato Terra
                  </Link>
                </li>
                {collaborators && collaborators.length > 0 && (
                  <li className={styles.text}>
                    <i className="fas fa-users"></i>
                    <Link
                      to="/minha-conta/colaboradores"
                      title="Perfis de colaboradores"
                    >
                      Perfis de Colaboradores
                    </Link>
                  </li>
                )}
                <li className={styles.text}>
                  <i className="fas fa-tasks"></i>
                  <Link
                    to="/minha-conta/historico-pedidos"
                    title="Histórico de pedidos"
                  >
                    Histórico de Pedidos
                  </Link>
                </li>
                <li className={styles.text}>
                  <i className="fas fa-money-check-alt"></i>
                  <Link
                    to="/minha-conta/pagamento-entrega"
                    title="Pagamento e entrega"
                  >
                    Pagamento e Entrega
                  </Link>
                </li>
              </>
            )}
            <li className={styles.text}>
              <button
                onClick={onWhatsappButton}
                className={styles.contactButton}
                aria-label="Abrir WhatsApp para entrar em contato"
                title="Entre em contato pelo WhatsApp"
                type="button"
              >
                Entre em Contato
              </button>
            </li>
            <li className={styles.text}>
              {isLoggedIn ? (
                <button type="button" onClick={logout} title="Sair da conta">
                  <span>Sair da conta</span>
                </button>
              ) : (
                <button type="button" title="Login">
                  <Link to={buttonAuth} title="Login">
                    <span>Login</span>
                  </Link>
                </button>
              )}
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default MobileMenu;
